var _g, _path, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgO3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 28,
    viewBox: "0 0 65 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2348_1588)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 28,
    rx: 10,
    fill: "#CAD6FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0581 16.296V14.976L32.9821 9.36H34.9381V14.832H35.9941V16.296H34.9381V18H33.2581V16.296H29.0581ZM33.3661 11.16L30.9061 14.832H33.3661V11.16ZM36.8597 10.8V9.252H39.7517V18H38.0237V10.8H36.8597ZM47.2914 10.704H43.4034V12.756C43.5714 12.548 43.8114 12.38 44.1234 12.252C44.4354 12.116 44.7674 12.048 45.1194 12.048C45.7594 12.048 46.2834 12.188 46.6914 12.468C47.0994 12.748 47.3954 13.108 47.5794 13.548C47.7634 13.98 47.8554 14.444 47.8554 14.94C47.8554 15.86 47.5914 16.6 47.0634 17.16C46.5434 17.72 45.7994 18 44.8314 18C43.9194 18 43.1914 17.772 42.6474 17.316C42.1034 16.86 41.7954 16.264 41.7234 15.528H43.3554C43.4274 15.848 43.5874 16.104 43.8354 16.296C44.0914 16.488 44.4154 16.584 44.8074 16.584C45.2794 16.584 45.6354 16.436 45.8754 16.14C46.1154 15.844 46.2354 15.452 46.2354 14.964C46.2354 14.468 46.1114 14.092 45.8634 13.836C45.6234 13.572 45.2674 13.44 44.7954 13.44C44.4594 13.44 44.1794 13.524 43.9554 13.692C43.7314 13.86 43.5714 14.084 43.4754 14.364H41.8674V9.228H47.2914V10.704ZM53.262 18L51.006 15.168V18H49.326V9.12H51.006V14.172L53.238 11.352H55.422L52.494 14.688L55.446 18H53.262Z",
    fill: "#2A2A2B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2348_1588)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5002,
    cy: 14.5001,
    r: 7.91667,
    stroke: "#2A2A2B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2502 9.75012C15.2502 9.33591 14.9144 9.00012 14.5002 9.00012C14.0859 9.00012 13.7502 9.33591 13.7502 9.75012V10.6161C13.3212 10.666 12.8758 10.7817 12.4932 11.02C12.0055 11.3237 11.6556 11.8078 11.5772 12.4676C11.5184 12.9627 11.5711 13.4176 11.7571 13.8192C11.944 14.2227 12.2377 14.512 12.5606 14.7198C13.1539 15.1018 13.9319 15.2545 14.5212 15.3701L14.5485 15.3754L14.5992 15.3853L14.5992 15.3854C14.9018 15.4447 15.1679 15.4969 15.4088 15.562C15.6646 15.6311 15.8411 15.7022 15.9579 15.7758C16.0639 15.8425 16.0938 15.8935 16.1074 15.9298C16.1237 15.9731 16.1517 16.0923 16.0885 16.3505C16.0576 16.4767 15.9737 16.5975 15.7399 16.7082C15.4896 16.8267 15.1247 16.9003 14.6811 16.9143C13.7758 16.943 12.8386 16.7192 12.4748 16.5275C12.1084 16.3344 11.6548 16.4749 11.4616 16.8413C11.2685 17.2078 11.409 17.6614 11.7755 17.8545C12.2359 18.0971 12.9738 18.2926 13.7502 18.3748V19.2501C13.7502 19.6643 14.0859 20.0001 14.5002 20.0001C14.9144 20.0001 15.2502 19.6643 15.2502 19.2501V18.3737C15.6406 18.3249 16.0315 18.2298 16.3817 18.064C16.9056 17.816 17.3795 17.3851 17.5455 16.7072C17.6571 16.2514 17.6642 15.8082 17.5115 15.402C17.3561 14.9887 17.069 14.7028 16.7574 14.5066C16.4567 14.3172 16.1152 14.1991 15.8002 14.114C15.506 14.0345 15.1904 13.9726 14.9025 13.9162L14.8375 13.9035C14.1725 13.773 13.6875 13.6614 13.3726 13.4586C13.2368 13.3712 13.162 13.2832 13.1181 13.1886C13.0734 13.0921 13.0331 12.9281 13.0668 12.6445C13.0879 12.4667 13.1589 12.3725 13.2862 12.2932C13.4463 12.1935 13.7116 12.1157 14.0877 12.0914C14.8378 12.0429 15.7456 12.2239 16.3154 12.4156C16.708 12.5476 17.1333 12.3364 17.2654 11.9438C17.3974 11.5512 17.1862 11.1259 16.7936 10.9939C16.3871 10.8571 15.8373 10.7211 15.2502 10.6451V9.75012Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2348_1588",
    x: -200,
    y: -200,
    width: 465,
    height: 428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2348_1588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2348_1588",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2348_1588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(5 5.00012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO3);
export default __webpack_public_path__ + "static/media/o3.19f81da3f0185a62aaae077c1dc14e0b.svg";
export { ForwardRef as ReactComponent };